import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-neutral-50" role="status" aria-live="polite">
      <div className="h-14 w-14 animate-spin rounded-full border-4 border-neutral-200 border-t-primary-500" aria-label="Loading spinner" />
      <p className="text-lg font-medium text-neutral-600">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
